import { Breadcrumb } from 'antd';
import { Link, useLocation } from 'react-router-dom';

const labelMap: Record<string, string> = {
  dashboards: 'Dashboards',
  edit: 'Edit',
  admin: 'Admin',
  users: 'Users',
  roles: 'Roles',
  permissions: 'Permissions',
  audit: 'Audit Logs',
  reports: 'Reports',
  settings: 'Settings',
  profile: 'Profile',
};

export function Breadcrumbs() {
  const location = useLocation();
  const parts = location.pathname.split('/').filter(Boolean);
  const items = parts.map((part, i) => {
    const path = '/' + parts.slice(0, i + 1).join('/');
    const label = labelMap[part] ?? part;
    return {
      title: i < parts.length - 1 ? <Link to={path}>{label}</Link> : label,
    };
  });
  return <Breadcrumb items={items} />;
}
